export default  function Procurement () {
    return(
        <div>
            Procurement pages
        </div>
    )
}